import(/* webpackMode: "eager" */ "/var/www/bhq-nextjs/src/app/[locale]/(main)/[hospital]/(homepage)/doctor/search/page.jsx");
